var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"timer"}},[(this.times)?_c('div',{staticClass:"tm"},[_c('span',[_vm._v(_vm._s(_vm.label))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }